import { DocumentTypeDescription } from './document-type-description';
import { type LegalReferenceAudience, LegalReferenceLink } from './legal-reference-link';

interface DocumentTypeHintSource {
  description: string | null;
  catalogKey: string | null;
  legalRefUrl: string | null;
  defaultValidityMonths: number | null;
}

interface DocumentTypeHintProps {
  documentType: DocumentTypeHintSource | null | undefined;
  audience?: LegalReferenceAudience;
}

/**
 * L'unico punto in cui un dialog spiega il tipo scelto: descrizione, fonte di legge e, solo
 * se il tipo ha una durata predefinita, l'avviso "valore indicativo". Sotto "ogni quanti mesi"
 * resta solo l'aiuto del campo.
 */
export function DocumentTypeHint({ documentType, audience = 'tenant' }: DocumentTypeHintProps) {
  if (!documentType) {
    return null;
  }
  return (
    <>
      <DocumentTypeDescription description={documentType.description} />
      <LegalReferenceLink
        catalogKey={documentType.catalogKey}
        legalRefUrl={documentType.legalRefUrl}
        showNotice={documentType.defaultValidityMonths !== null}
        audience={audience}
      />
    </>
  );
}
